



















































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";
import Button from "@/shared/components/ui/Button.vue";
import {
  QuickSightReportType,
  RoleType,
  QuickSightReport,
  UserPermission
} from "@/shared/types";
import { Validator } from "vee-validate";
import {
  QuickSightReportsList
} from "@/admin/route-names";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { usePartnerStore } from "@/admin/store/partner";
import { useQuickSightReportStore } from "@/admin/store/quickSightReport";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {
    Button
  }
})
export default class QuickSightReportManage extends Vue {
  $validator: Validator;

  QuickSightReportsList = QuickSightReportsList;

  partnerStore = usePartnerStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();
  quickSightReportStore = useQuickSightReportStore();
  rolePermissionsStore = useRolePermissionsStore();
  @Prop() reportId: number;

  model: QuickSightReport = {
    quickSightReportId: 0,
    reportLinkId: "",
    reportName: "",
    reportType: QuickSightReportType.None,
    reportCategoryId: 0,
    reportCategoryName: "",
    allowedRoles: [],
    isEnabled: false,
    partnerIds: [],
    dateCreated: null,
    isSubReport: false
  };
  modelPristine: QuickSightReport = null;
  isPosting = false;

  initializeModel () {
    this.model = {
      quickSightReportId: 0,
      reportLinkId: "",
      reportName: "",
      reportType: QuickSightReportType.None,
      reportCategoryId: 0,
      reportCategoryName: "",
      allowedRoles: [],
      isEnabled: false,
      partnerIds: [],
      dateCreated: null,
      isSubReport: false
    };
    this.modelPristine = { ...this.model };
  }

  get canDelete (): boolean {
    return this.reportId && !this.model.isEnabled && _.isEqual(this.modelPristine, this.model);
  }

  get isReportTypeDisabled (): boolean {
    return !!this.reportId;
  }

  @Watch("quickSightReportStore.reports")
  loadReport (): void {
    if (!this.quickSightReportStore.reports && !this.quickSightReportStore.reports.length) {
      return;
    }

    if (!this.reportId) {
      return;
    }

    const report: QuickSightReport = this.quickSightReportStore.reportById(this.reportId);

    if (!report) {
      return;
    }

    // if partner ids selection is empty,
    // preselect the all partners option
    if (!report.partnerIds.length) {
      report.partnerIds = [ 0 ];
    }

    this.model = { ...report };
    this.modelPristine = { ...report };
  }

  mounted (): void {
    this.partnerStore.reload();
    this.quickSightReportStore.getCategories();
    this.employerRolePermissionStore.getRoles();
    this.quickSightReportStore.getReports();
    this.initializeModel();
  }

  get isLoaded () {
    return this.employerRolePermissionStore.isRolesLoaded && this.quickSightReportStore.isCategoryLoaded &&
        this.quickSightReportStore.isLoaded;
  }

  get reportTypeOptions () {
    const keys = Object.keys(QuickSightReportType)
        .filter(k => QuickSightReportType[k] !== QuickSightReportType.None)
        .map(k => ({ value: QuickSightReportType[k], text: k }));
    keys.unshift({ value: QuickSightReportType.None, text: "Select Report Type" });
    return keys;
  }

  @Watch("model.reportType")
  resetRoles () {
    if (!this.reportId) {
      this.model.allowedRoles = [];
    }
  }

  get partnerOptions () {
    const keys = this.partnerStore.allPartners.map(k => ({ value: k.id, text: k.name }));
    keys.push({ value: 0, text: "All Partners" });
    return _.sortBy(keys, "value");
  }

  get categories () {
    const keys = this.quickSightReportStore.reportCategories.map(
        k => ({ value: k.reportCategoryId, text: k.categoryName }));
    keys.push({ value: 0, text: "Select Report Category" });
    return _.sortBy(keys, "value");
  }

  get filteredRoles () {
    if (this.model.reportType === QuickSightReportType.Employer) {
      return this.employerRolePermissionStore.allRoles.map(k => ({ value: k.roleId, text: k.roleName }));
    } else if (this.model.reportType === QuickSightReportType.Partner) {
      return this.employerRolePermissionStore.allRoles.filter(e => e.roleType === RoleType.Partner)
          .map(k => ({ value: k.roleId, text: k.roleName }));
    } else {
      return [];
    }
  }

  onDeleteClick (): void {
    if (confirm("Are you sure you would like to delete report: " + this.model.reportName + "?")) {
      this.quickSightReportStore.deleteReport(this.reportId).then(() => {
        this.$router.push({ name: QuickSightReportsList });
      });
    }
  }

  submit (): void {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      // if we have selected the all partners option,
      // clear the array so all records in quickSightPartner db table are set to deleted
      if (_.includes(this.model.partnerIds, 0)) {
        this.model.partnerIds = [];
      }

      this.isPosting = true;
      this.quickSightReportStore.saveQuickSightReport(this.model).then(e => {
        this.isPosting = false;
        this.modelPristine = { ...this.model };

        if (this.model.quickSightReportId === 0) {
          this.$router.push({ name: QuickSightReportsList });
        }
      });
    });
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityQuickSightReptEdit);
  }
}
